import React from 'react';
import DetailedHeader from '../../../../components/ProjectDetailedPageComponents/DetailedHeader';
import Seo from '../../../../components/Misc/Seo';
import ImageSlider from '../../../../components/Misc/ImageSlider';
import projectImage1 from '../../../../assets/images/work/nxr/NXR_Slider_1.webp';
import projectImage2 from '../../../../assets/images/work/nxr/NXR_Slider_2.webp';
import projectImage3 from '../../../../assets/images/work/nxr/NXR_Slider_3.webp';
import projectImage4 from '../../../../assets/images/work/nxr/NXR_Slider_4.webp';

import Data_NXR from './Data_NXR';

function Work_NXR() {
    const canonical = 'https://studio.norcat.org/OurWork/norcat-nxr';
    const title = 'NXR | Studio NORCAT - Driven by experiences that matter.';
    const description = 'Developed by Studio NORCAT, NXR is a content delivery platform that helps organizations manage, update, and distribute immersive training experiences across connected devices and locations.';

    return (
        <>
            <Seo
                title={title}
                description={description}
                canonical={canonical}
                ogTitle={title}
                ogDescription={description}
                ogImage={`${window.location.origin}${projectImage1}`}
                ogImageAlt="Preview of the NXR platform project"
                twitterTitle={title}
                twitterDescription={description}
                twitterImage={`${window.location.origin}${projectImage1}`}
                twitterImageAlt="Preview of the NXR platform project"
            />
            <DetailedHeader
                heading="A Platform for Continuous Content Delivery"
                client="NORCAT"
                service="Platform"
                date="2019-Present"
            />
            <ImageSlider
                noArt="true"
                swiperNav="true"
                useButtonNav="true"
                images={[
                    {
                        image: projectImage1,
                        alt: 'NXR project screenshot 1',
                    },
                    {
                        image: projectImage2,
                        alt: 'NXR project screenshot 2',
                    },
                    {
                        image: projectImage3,
                        alt: 'NXR project screenshot 3',
                    },
                    {
                        image: projectImage4,
                        alt: 'NXR project screenshot 4',
                    },
                ]}
            />

            {Data_NXR.content}
        </>
    );
}

export default Work_NXR;
